export default {
  props: ['isMorePhotosSection'],
  data() {
    return {
      activeTags: [],
      staticTags: null,
      privateTags: [],
      hasPrivateTags: false,
    }
  },
  computed: {
    tags() {
      return this.$store.getters.TAGS;
    },
    activeTag() {
      return this.$store.getters.CURRENT_TAG;
    },
    currentSortParam() {
      return this.$store.getters.CURRENT_SORT_PARAM;
    },
    mobileTagMenu() {
      return this.$store.getters.MOBILE_TAG_MENU;
    },
    isProduction() {
      return process.env.VUE_APP_IS_PRODUCTION === 'true';
    },
    isPrivateTag() {
      return this.activeTag && this.activeTag.url_hash
          && this.activeTag.url_hash.split('-').length > 1;
    }
  },
  watch: {
    /*orderStep(step, prevStep) {
      if (prevStep && !step) {
        this.setActiveTag(null);
      }
    },*/
    customerItems() {
      this.setActiveTags();
    },
    tags(tags) {
      if (tags) {
        this.staticTags = tags.filter(tag => {
          if (tag.password_hash) {
            this.privateTags.push(tag);

            if (this.$route.params.tag === `${tag.hash}-${tag.password_hash}`) {
              tag.hide_tag_in_frontend = '0';
            }
          }

          return !tag.password_hash || this.$route.params.tag === `${tag.hash}-${tag.password_hash}`;
        });

        this.hasPrivateTags = this.privateTags.length > 0;

        if (this.$route.params.tag) {
          const url_hash = this.$route.params.tag;
          const localTag = this._.find(this.tags, {url_hash});

          let tag = {
            url_hash,
            password_hash: '',
          };

          if (localTag) {
            tag = localTag;
          }

          this.setActiveTag(tag, false, false);
        }
      }
    },
  },
  methods: {
    isOpenTag(tag) {
      return !!this._.find(this.activeTags, {tag_url: tag.url_hash});
    },
    setActiveTags() {
      const albumId = this.album.is_private
          ? `${this.album.hash}-${this.album.hash_password}`
          : this.album.id;

      this.activeTags = this.customerItems.filter(item => item.tag_url && item.hash === albumId);
    },
    setActiveTag(tag, showModal = true, request = true) {
      if (this.isMobile) {
        this.$store.dispatch('SET_MOBILE_TAG_MENU', false);
      }

      if (tag && tag === this.activeTag) {
        tag = null;
        this.handleActiveTag(tag, showModal, request);
      } else if (tag !== this.activeTag) {
        this.handleActiveTag(tag, showModal, request);
      }
    },
    async handleActiveTag(tag, showModal = true, request = true) {
      if (tag && tag.password_hash !== '' && showModal && !this.isOpenTag(tag)) {
        this.showSecuredTagModal(tag, this.isMorePhotosSection);
      } else if (!request) {
        this.$store.dispatch('SET_CURRENT_TAG', tag ? tag : null);
      } else {
        this.$store.dispatch('SET_CURRENT_TAG', tag ? tag : null);

        let loader;

        if (this.isMorePhotosSection) {
          loader = this.$loading.show();
        } else {
          this.$store.dispatch('LOADING_PHOTOS_BY_PARAMS', true);
        }

        let albumPhotos = [];

        try {
          const albumId = this.album.is_private
              ? `${this.album.hash}-${this.album.hash_password}`
              : this.album.id;

          const params = [];

          if (this.currentSortParam) {
            params.push(`sorting=${this.currentSortParam}`);
          }

          if (tag) {
            params.push(`tag=${tag.url_hash}`);
          }

          const result = await this.axios.get(`/v2/albums/${albumId}/items${params.length > 0 ? `?${params.join('&')}` : ''}`);

          if (result && result.data.success) {
            albumPhotos = result.data.data;

            if (!this.isMorePhotosSection) {
              if (tag) {
                const tagHash = tag.url_hash;
                const path = this.i18nLink(
                    `album/gallery/${this.$route.params.hash}/tag/${tagHash}`);

                if (path !== this.$router.currentRoute.path) {
                  this.$router.push(path);
                }
              } else if (this.$route.name !==
                  this.$router.currentRoute.path) {
                this.$router.push(
                    this.i18nLink(`album/gallery/${this.$route.params.hash}`));
              }
            }
          }

          this.$store.dispatch('SET_ALBUM_PHOTOS', albumPhotos);

          if (this.isMorePhotosSection) {
            loader.hide();
          } else {
            this.$store.dispatch('LOADING_PHOTOS_BY_PARAMS', false);
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
          this.$store.dispatch('LOADING_PHOTOS_BY_PARAMS', false);
        }
      }
    },
  },
  created() {
    this.setActiveTags();
  },
}
